import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ListFormeFillingWidget from '../../../widgets/eFillingListFormWidgets/ListFormeFillingWidget'
import '../styles.less'
import { getEfilling, searchEfilling } from '../../../redux/actions/eFilling'

export default function eFillingListForm() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const pageNumber = 0
  const pageSize = 0
  const projectCode = sessionStorage.getItem('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await searchEfilling({projectCode : projectCode}, pageNumber, pageSize)
      setSchema(response.model)
      // console.log('response==>', response)
      // setSchema(mockSchema.model)
      // console.log('mockSchema==>', schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <ListFormeFillingWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    header: 'นำเข้าข้อมูลยื่น eFilling',
    subHeader: '',
    disabled: false,
    forms: {
      header: 'เพิ่มข้อมูลยื่น eFilling',
      modelType: {
        name: 'modelType',
        label: 'ประเภทแบบ',
        value: '',
        options: [
          {
            disabled: false,
            label: 'ภ.ง.ด.1',
            value: '1',
          },
          {
            disabled: false,
            label: 'ภ.ง.ด.3',
            value: '2',
          },
          {
            disabled: false,
            label: 'ภ.ง.ด.53',
            value: '3',
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณาเลือกรายการ',
          },
        ],
      },
      submitStartDate: {
        name: 'submitStartDate',
        label: 'วันที่ยื่นแบบเริ่มต้น',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกวันที่ยื่นแบบเริ่มต้น',
          },
        ],
      },
      submiyEndDate: {
        name: 'submiyEndDate',
        label: 'วันที่ยื่นแบบสิ้นสุด',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกวันที่ยื่นแบบสิ้นสุด',
          },
        ],
      },
      projectCode: {
        name: 'projectCode',
        label: 'รหัสโครงการ  ',
        value: '66-00018',
        disabled: false,
      },
      contractNo: {
        name: 'contractNo',
        label: 'เลขที่ข้อตกลง ',
        value: '66-P1-0011',
        disabled: false,
      },
      submisList: {
        name: 'submisList',
        label: 'ลำดับการยื่นแบบ',
        value: null,
        disabled: false,
      },
      submisStatus: {
        name: 'submisStatus',
        label: 'สถานะยื่นแบบ',
        value: '',
        options: [
          {
            disabled: false,
            label: 'รอนำส่ง',
            value: '1',
          },
          {
            disabled: false,
            label: 'อยู่ระหว่างดำนเนินการ',
            value: '2',
          },
          {
            disabled: false,
            label: 'ยื่นแบบสำเร็จ ',
            value: '3',
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณาเลือกรายการ',
          },
        ],
      },
      taxReferCode: {
        name: 'taxReferCode',
        label: 'รหัสอ้างอิงการยื่นภาษี',
        value: null,
        disabled: false,
      },
      submisType: {
        name: 'submisType',
        label: 'ลักษณะการยื่น',
        value: '',
        options: [
          {
            disabled: false,
            label: 'ยื่นปกติ',
            value: '1',
          },
          {
            disabled: false,
            label: 'ยื่นเพิ่มเติมย้อนหลัง',
            value: '2',
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณาเลือกรายการ',
          },
        ],
      },
      dataType: {
        name: 'dataType',
        label: 'ประเภทข้อมูล',
        value: '',
        options: [
          {
            disabled: false,
            label: 'นำเข้า',
            value: '1',
          },
          {
            disabled: false,
            label: 'บันทึกผ่านระบบ',
            value: '2',
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณาเลือกรายการ',
          },
        ],
      },
      attachTaxFiles: {
        name: 'attachTaxFiles',
        label: 'แนบเอกสารรายชื่อผู้เสียภาษี',
        value: [],
      },
      attachReceiptFiles: {
        name: 'attachReceiptFiles',
        label: 'แนบใบเสร็จรับเงิน',
        value: [],
      },
      attachFormTaxFiles: {
        name: 'attachFormTaxFiles',
        label: 'แนบแบบภาษี',
        value: [],
      },
      submisDate: {
        name: 'submisDate',
        label: 'วันที่ยื่นแบบ',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกวันที่ยื่นแบบ',
          },
        ],
      },
      taxMonth: {
        name: 'taxMonth',
        label: 'เดือนที่ยื่นภาษี',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกรายการ',
          },
        ],
      },
      receiptDate: {
        name: 'receiptDate',
        label: 'วันที่ในใบเสร็จรับเงิน ',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกวันที่ในใบเสร็จรับเงิน',
          },
        ],
      },
      submitName: {
        name: 'submitName',
        label: 'ชื่อผู้ยื่นแบบ',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกชื่อผู้ยื่นแบบ',
          },
        ],
      },
      phoneNumber: {
        name: 'phoneNumber',
        label: 'เบอร์โทรติดต่อ ',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกเบอร์โทรติดต่อ ',
          },
        ],
      },
      submisFormType: {
        name: 'submisFormType',
        label: 'รูปแบบการยื่นแบบ',
        value: '',
        options: [
          {
            disabled: false,
            label: 'eFilling',
            value: '1',
          },
          {
            disabled: false,
            label: 'กระดาษ',
            value: '2',
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณาเลือกรายการ',
          },
        ],
      },
    },
    eFillingListValues: [
      {
        id: '9F262C5E-6870-122E-ADBA-172E3DC1903A',
        projectCode: '66-00019',
        contractNo: '66-P1-0012',
        submisDate: '07/ก.พ./2567',
        modelType: '1',
        modelTypeLabel: 'ภ.ง.ด.1',
        taxMonth: 'ก.พ./2567',
        submisList: '001',
        taxReferCode: '862435EE-87E1',
        submisType: '1',
        submisTypeLabel: 'ยื่นปกติ',
        dataType: '1',
        dataTypeLabel: 'นำเข้า',
        submisStatus: '1',
        submisStatusLabel: 'รอนำส่ง',
        isEditabled: true,
      },
      {
        id: '862435EE-87E1-3211-BF6A-893751DA233A',
        projectCode: '66-00019',
        contractNo: '66-P1-0012',
        submisDate: '14/ก.พ./2567',
        modelType: '1',
        modelTypeLabel: 'ภ.ง.ด.1',
        taxMonth: 'พ.ค./2567',
        submisList: '002',
        taxReferCode: '542435EE-87E1',
        submisType: '1',
        submisTypeLabel: 'ยื่นปกติ',
        dataType: '2',
        dataTypeLabel: 'บันทึกผ่านระบบ',
        submisStatus: '2',
        submisStatusLabel: 'อยู่ระหว่างดำนเนินการ',
        isEditabled: true,
      },
      {
        id: '772435EE-87E1-3211-BF6A-893751DA233A',
        projectCode: '66-00019',
        contractNo: '66-P1-0012',
        submisDate: '18/ก.พ./2567',
        modelType: '2',
        modelTypeLabel: 'ภ.ง.ด.3',
        taxMonth: 'ธ.ค./2567',
        submisList: '003',
        taxReferCode: '762435EE-87E1',
        submisType: '2',
        submisTypeLabel: 'ยื่นเพิ่มเติมย้อนหลัง',
        dataType: '1',
        dataTypeLabel: 'นำเข้า',
        submisStatus: '3',
        submisStatusLabel: 'ยื่นแบบสำเร็จ',
        isEditabled: true,
      },
    ],
  },
}
